<div class="container-fluid grey-bg form-wrapper thankyou-wrapper">
    <div class="row">
      <div class="col-12">
        <div class="form-box text-center">
          <div class="top-detail">
            <a href="/" title="Back to Home"><img alt="world of sweets logo" src="../../assets/images/bonds-logo.svg" /></a>
          </div>
          <img src="/assets/images/success.svg"/>
          <h2>Success!</h2>
        </div>
        <app-footer></app-footer>
      </div>
    </div>
  </div>

  